// extracted by mini-css-extract-plugin
export var aboutAdvance = "aboutAdvance-module--about-advance--bdb13";
export var aboutAdvance__licenses = "aboutAdvance-module--about-advance__licenses--11033";
export var aboutAdvance__text = "aboutAdvance-module--about-advance__text--b1249";
export var aboutAdvance__textLicenses = "aboutAdvance-module--about-advance__text--licenses--27db7";
export var aboutAdvance__title = "aboutAdvance-module--about-advance__title--95a43";
export var aboutAdvance__wrap = "aboutAdvance-module--about-advance__wrap--cfecf";